<!-- Overrides @basecom-gmbh/pond/components/Layout/LayoutBreadcrumps.vue -->
<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const { breadcrumbs } = useBreadcrumbs();
const router = useRouter();
const route = useRoute();
const { history } = useRouter().options;

withDefaults(
    defineProps<{
        displayRoot?: boolean;
        rootIcon?: string;
    }>(),
    {
        displayRoot: true,
        rootIcon: '',
    },
);
</script>

<template>
    <!-- IDS-84 - change styles -->
    
<FormKitLazyProvider config-file="true">
<ClientOnly>
        <div
            v-if="history?.state?.back && route.fullPath !== '/'"
            class="mt-6 flex cursor-pointer px-6 md:hidden"
            @click="router.back()"
        >
            <FormKitIcon
                icon="arrow-left"
                class="mr-2 block w-3"
            />{{ $t('global.backLink') }}
        </div>
    </ClientOnly>
    <!-- IDS-234 - hide breadcrumb on homepage -->
    <nav
        v-if="route.fullPath !== '/'"
        class="container mx-auto my-8 hidden md:flex"
        :aria-label="$t('layout.breadcrumb.ariaLabel')"
    >
        <ol class="inline-flex items-center gap-2">
            <li
                v-if="displayRoot"
                class="inline-flex items-center gap-2"
            >
                <LocaleLink
                    :to="'/'"
                    class="inline-flex items-center gap-2 text-xs"
                >
                    <FormKitIcon
                        v-if="rootIcon"
                        :icon="rootIcon"
                        class="h-4 w-4"
                    />
                    {{ $t('layout.breadcrumb.homeLinkLabel') }}
                </LocaleLink>

                <span
                    v-if="breadcrumbs?.length > 0"
                    class="text-xs"
                    >/</span
                >
            </li>

            <li
                v-for="(breadcrumb, index) in breadcrumbs"
                :key="breadcrumb.path"
                class="inline-flex items-center gap-2"
            >
                <LocaleLink
                    v-if="breadcrumb.path"
                    :to="breadcrumb.path"
                    class="inline-flex items-center text-xs"
                >
                    {{ breadcrumb.name }}
                </LocaleLink>

                <span
                    v-else
                    class="inline-flex items-center text-xs"
                >
                    {{ breadcrumb.name }}
                </span>
                <span
                    v-if="index < breadcrumbs.length - 1"
                    class="text-xs"
                    >/</span
                >
            </li>
        </ol>
    </nav>
</FormKitLazyProvider>

</template>
